let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3UiHl")).then(() => parcelRequire('3g0Pk'));